<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="TOC"><a href="#/Preface">Preface</a></p>
<p class="TOC"><a href="#/Acknowledgments">Acknowledgements</a></p>
<p class="TOC1"><a href="#/Chapter1">Mysterious Deaths</a></p>
<p class="TOC"><a href="#/Chapter2">A Dream Halted</a></p>
<p class="TOC"><span href="#/Chapter3" title="Link target outside of Sample">A Family in Flight</span></p>
<p class="TOC"><span href="#/Chapter4" title="Link target outside of Sample">Outsiders in the Valley</span></p>
<p class="TOC"><span href="#/Chapter5" title="Link target outside of Sample">Boy-Crazy</span></p>
<p class="TOC"><span href="#/Chapter6" title="Link target outside of Sample">Grave Suspicions</span></p>
<p class="TOC"><span href="#/Chapter7" title="Link target outside of Sample">The Investigation Begins</span></p>
<p class="TOC"><span href="#/Chapter8" title="Link target outside of Sample">The Investigation Stalls</span></p>
<p class="TOC"><span href="#/Chapter9" title="Link target outside of Sample">To Catch a Killer</span></p>
<p class="TOC"><span href="#/Chapter10" title="Link target outside of Sample">Tabloid Celebrity</span></p>
<p class="TOC"><span href="#/Chapter11" title="Link target outside of Sample">The Trial Begins</span></p>
<p class="TOC"><span href="#/Chapter12" title="Link target outside of Sample">The Defense Gathers Steam</span></p>
<p class="TOC"><span href="#/Chapter13" title="Link target outside of Sample">Closing and Verdict</span></p>
<p class="TOC"><span href="#/Chapter14" title="Link target outside of Sample">Asyla</span></p>
<p class="TOC"><span href="#/Chapter15" title="Link target outside of Sample">The Legend Ripples Outward</span></p>
<p class="TOC1"><span href="#/Epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="TOC"><span href="#/Appendices" title="Link target outside of Sample">Appendices</span></p>
<p class="TOC"><span href="#/Bibliography" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?394e70d5